import React,{Component} from 'react'
// import * as firebase from 'firebase';
import firebase from '../helper/firebase'

import {
  Button,
  Card,
  CircularProgress,
  Divider,
} from 'material-ui'

import Fade from 'material-ui/transitions/Fade'

import JobCardHeader from './JobCardHeader'

import {
  GetNotificationsPermission,
  ReactGoogleAnalytics,
} from '../helper/functions'

import {
  Green
} from '../helper/consts'

const style = {
  wrapper: {
    position: 'relative',
    display:'flex',
    width:'100%',
  },
  // card:{
  //   height:'fit-content',
  //   margin:'11px 0',
  //   width:'450px',
  //   display:'flex',
  //   alignItems:'center',
  //   flexDirection:'column',
  //   backgroundColor:'blue',
  // },
  button:{
    width:'100%',
  },
  buttonProgress: {
    color: Green,
    position: 'absolute',
    width: '24px',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}

export default class OfferSubscribeCard extends Component{
  constructor(props){
    super(props);

    this.state = {
      loading:true,
      token:'',
    }
  }

  componentWillUnmount(){
    firebase.database().ref(`settings/${this.props.uid}`).off();
  }

  componentDidMount(){
    this.getInfo();
    // const ref = firebase.database().ref();
    // ref.child(`settings/${this.props.uid}`).on('value',snap=>{
    //   if(snap.val()!==null){
    //     this.setState({
    //       token:snap.val().token || '',
    //       notifications:snap.val().notifications || false,
    //       loading:false,
    //     })
    //   }
    //   else{
    //     this.setState({
    //       token:'',
    //       loading:false,
    //     })
    //   }
    // },
    // err=>{
    //   console.log(err);
    // })
  }

  getInfo=()=>{
    const {uid,job} = this.props;
    const ref = firebase.database().ref();
    let promises=[];
    const settingsPromise = ref.child(`settings/${uid}`).on('value',settingsSnap=>{
      if(settingsSnap.val()!==null){
        this.setState({
          token:settingsSnap.val().token || '',
          notifications:settingsSnap.val().notifications || false,
        })
      }
      else{
        this.setState({
          token:'',
          notifications:false,
        })
      }
    },
    err=>{
      console.log(err);
    })
    promises.push(settingsPromise);
    const subscriptionsPromise = ref.child(`subscriptions/${uid}/${job.jid}`).once('value')
    .then(subscriptionSnap=>{
      if(subscriptionSnap.val()!==null){
        this.setState({subscribed:true})
      }
      else{
        this.setState({subscribed:false})
      }
    })
    promises.push(subscriptionsPromise);
    Promise.all(promises)
    .then(()=>{
      this.setState({loading:false})
    })
  }

  getPermission=()=>{
    GetNotificationsPermission(this.props.uid);
  }

  subscribe=()=>{
    this.setState({subscribing:true})
    const {uid,job,offer} = this.props;
    const ref = firebase.database().ref();
    ref.child(`subscriptions/${uid}/${job.jid}`).update({
      oid:offer.oid,
      jid:job.jid,
      timestamp:Date.now(),
    })
    .then(()=>{
      ReactGoogleAnalytics('Jobs','Subscribe',job.jid,null,null);
      this.setState({subscribed:true,subscribing:false})
    })
    .catch(err=>{
      console.log(err);
      this.setState({subscribing:false})
    })
  }

  unsubscribe=()=>{
    this.setState({subscribing:true})
    const {uid,job} = this.props;
    const ref = firebase.database().ref();
    ref.child(`subscriptions/${uid}/${job.jid}`).remove()
    .then(()=>{
      this.setState({subscribed:false,subscribing:false})
    })
    .catch(err=>{
      console.log(err);
      this.setState({subscribing:false})
    })
  }

  render(){
    return(
      !this.state.loading &&
        <Fade in={!this.state.loading} >
          <Card className='card rightCard'>
            <JobCardHeader job={this.props.job} />
            <Divider light />
            <div style={style.wrapper}>
              {this.state.token.length===0 || !this.state.notifications?
                <Button
                  raised={!this.state.subscribing && !this.state.subscribed && this.state.token.length===0}
                  style={style.button}
                  color="primary"
                  disabled={this.state.subscribing || this.state.subscribed || this.state.token.length>0}
                  onClick={this.getPermission}
                  className='subscribeButton'
                >
                  Permit Notifications
                </Button>
              :
                null
              }
              {this.state.token.length!==0 && this.state.notifications && !this.state.subscribed?
                <Button
                  raised={!this.state.subscribing && !this.state.subscribed}
                  style={style.button}
                  color="primary"
                  disabled={this.state.subscribing || this.state.subscribed}
                  onClick={this.subscribe}
                  className='subscribeButton'
                >
                  Subscribe To Alerts
                </Button>
              :
                null
              }
              {this.state.subscribing && <CircularProgress size={24} style={style.buttonProgress} />}
              {this.state.subscribed?
                <Button
                  raised={false}
                  style={style.button}
                  color="primary"
                  disabled={true}
                  className='subscribeButton'
                >
                  Subscribed
                </Button>
              :
                null
              }
            </div>
          </Card>
        </Fade>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/OfferSubscribeCard.js